import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const integrityHonesty: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.INTEGRITY_HONESTY,
  label: "Integrity and honesty",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "what the false or misleading information was, or what the dishonest act was",
    "when and where it occurred (application, resume, official document, exam, assignment)",
    "how it was resolved and what the consequence was",
    "what the candidate learned",
  ],
  followUpTriggers: [
    "the answer is vague about exactly what information or act was involved",
    "whether it was recent or material is unclear",
    "there's no indication of consequence or what changed since",
  ],
  hardBarrierFacts: [
    "offering or accepting a bribe, kickback, or improper payment — automatic high priority regardless of how it was resolved",
    "falsification of an application, resume, or official document confirmed to be recent or material",
  ],
  crossCuttingNotes: [
    "academic dishonesty (cheating on an exam or assignment, plagiarism, submitting work that wasn't the candidate's own) is scored under this category",
    "admitted academic dishonesty (the candidate says they cheated, plagiarized, or submitted work that wasn't their own) is at minimum a standard flag once disclosed — however old, whether or not it was caught, and however well the candidate owns it; still probe for when it happened, the outcome, and what changed so the reviewer has the whole story",
    "helping someone else cheat, knowingly sharing work that got copied, or being formally accused of academic misconduct counts here too — whether or not the candidate was found responsible",
  ],
};
